// extracted by mini-css-extract-plugin
export default {"infoBlock":"InfoBlock_infoBlock__gjEWK","img":"InfoBlock_img__vRvHy","description":"InfoBlock_description__Snguy","blockWrap":"InfoBlock_blockWrap__OAhPT"};